import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { useRef } from "react"
import "./custom.css"
import Slider from "react-slick"
import dot from "./dot.json"

import {
  backgroundStyle,
  containerStyle,
  redDotStyle,
  streamNameStyle,
  streamStyle,
} from "./style"
import makeStyles from "pages/style"
import Lottie from "react-lottie-player"
import { ChevronLeft, ChevronRight } from "@mui/icons-material"
import InfoIcon, { TooltipIconColor, TooltipType } from "components/InfoIcon"
import { teacherInfoIconBlock } from "components/InfoIcon/teacherInfoIcon"
import companyTripOnAir from "assets/images/apollo-english/company-trip-on-air.jpg"
import appBannerOnAir from "assets/images/apollo-english/app-banner-on-air.jpg"
import useImageWithFallback from "shared/hooks/useImageWithFallback"

const COMPANY_TRIP_URL =
  "https://apollo.edu.vn/company-trip-2026?zarsrc=31&utm_source=zalo&utm_medium=zalo&utm_campaign=zalo"

const FALLBACK_IMG_URL =
  "https://crmlearn.sgp1.digitaloceanspaces.com/images/Cover_ApolloOnaircopy.jpg"

const ON_AIR_SLIDES = [
  {
    imgUrl: companyTripOnAir,
    linkUrl: COMPANY_TRIP_URL,
  },
  {
    imgUrl: appBannerOnAir,
    linkUrl: "",
  },
]

// One slide — its own component so useImageWithFallback (a hook) can run
// per item instead of inside the .map() below.
const AdvertiseSlide = ({ item, classes }) => {
  const imgUrl = useImageWithFallback(item.imgUrl, FALLBACK_IMG_URL)
  return (
    <MDBox
      width="100%"
      height="100%"
      sx={{ cursor: "pointer " }}
      onClick={() => {
        if (item.linkUrl) {
          window.open(item.linkUrl, "_blank")
        }
      }}
    >
      <MDBox sx={(theme) => backgroundStyle(theme, { bgImage: imgUrl })}>
        <MDBox sx={(theme) => streamStyle(theme)}>
          <MDBox className={classes.containerDisplayFlex}>
            <MDTypography sx={(theme) => streamNameStyle(theme)}>
              APOLLO ON AIR
            </MDTypography>
            <InfoIcon
              teacherInfoIconBlock={teacherInfoIconBlock.APOLLO_ON_AIR}
              type={TooltipType.TYPE_2}
              color={TooltipIconColor.BLUE}
              className={classes.containerInfoIconWith2}
            />
          </MDBox>
          <MDBox sx={(theme) => redDotStyle(theme)}>
            <Lottie animationData={dot} play />
          </MDBox>
        </MDBox>
      </MDBox>
    </MDBox>
  )
}

function Advertise() {
  const sliderRef = useRef(null)

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const classes = makeStyles()

  return (
    <MDBox width="100%" height="100%" sx={(theme) => containerStyle(theme)}>
      <Slider ref={sliderRef} {...settings}>
        {ON_AIR_SLIDES.map((item, index) => (
          <AdvertiseSlide key={index} item={item} classes={classes} />
        ))}
      </Slider>

      {/* <MDBox height="100%">
        <iframe
          height="125%"
          width={"100%"}
          src="https://demo-lesson.sgp1.digitaloceanspaces.com/2023-11-1-ApolloShootingDay2-Script9-final2.mp4"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </MDBox> */}

      <MDBox
        sx={({ functions: { pxToRem } }) => ({
          position: "absolute",
          top: pxToRem(48),
          right: pxToRem(48),
          zIndex: 99,
          display: "flex",
          gap: 2,
        })}
      >
        <MDBox
          sx={{
            cursor: "pointer",
            background: "#fff",
            width: 40,
            height: 40,
            borderRadius: 20,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => sliderRef?.current?.slickPrev()}
        >
          <ChevronLeft sx={{ color: "#000", height: 28, width: 28 }} />
        </MDBox>
        <MDBox
          sx={{
            cursor: "pointer",
            background: "#fff",
            width: 40,
            height: 40,
            borderRadius: 20,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => sliderRef?.current?.slickNext()}
        >
          <ChevronRight sx={{ color: "#000", height: 28, width: 28 }} />
        </MDBox>
      </MDBox>
    </MDBox>
  )
}

export default Advertise
